import { TIMEZONE_ZONES, TimezoneOption } from 'src/app/shared/utils/timezone-zones.constant';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { OnInit, OnDestroy, Component, ElementRef, Inject, TemplateRef, ViewChild } from '@angular/core';
import { NavigationEnd, ActivatedRoute, Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AbstractControl, FormBuilder, FormControl, FormGroup, UntypedFormArray, UntypedFormBuilder, ValidatorFn, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Constant } from 'src/app/constant/constant';
import { Location } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { CustomFlexLayoutModule } from 'src/app/shared/flex-layout/custom-flex-layout.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { CalsoftpipeModule } from 'src/app/shared/utils/calsoftpipe/calsoftpipe.module';
import { CommonModule } from '@angular/common';
import { CalsoftAuditComponent } from 'src/app/pages/audit/audit.component';
import { CommonService } from 'src/app/services/common.service';
import { GoogleCalendarServiceAccountService } from 'src/app/services/google-calendar-service-account.service';
import { ProductService } from 'src/app/services/product.service';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
import * as XLSX from 'xlsx';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { CompaniesService } from 'src/app/services/companies.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { logging } from 'protractor';


@Component({
  selector: 'calsoft-add-meeting',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    CustomFlexLayoutModule,
    SharedModule,
    CalsoftpipeModule
  ],
  templateUrl: './add-meeting.component.html',
  styleUrls: ['./add-meeting.component.scss']
})
export class AddMeetingComponent implements OnInit, OnDestroy {

  url = '';
  sanitizedUrl = '';


  firstFormGroup: FormGroup;
  text: any;
  title: string;
  id: any;
  resourcePrivilege: any;
  path: string;
  filtereddropdownTypeList: any;
  customerLinkList: any = [];
  _onDestroy = new Subject<void>();
  form: any;
  addedFieldId: any = [];
  leadDisplay: boolean = true;
  crmSettingsData: any;
  editMeeetingLink: any = 0;

  data: any;
  isOptionSelected: boolean;

  minDate: Date = new Date();

  constructor(
    public dialogRef: MatDialogRef<AddMeetingComponent>,
    @Inject(MAT_DIALOG_DATA) data,
    private _formBuilder: UntypedFormBuilder,
    private router: Router,
    private googleCalendarServiceAccountService: GoogleCalendarServiceAccountService,
    private snackBar: MatSnackBar,
    public location: Location,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private commonService: CommonService,
    private fb: FormBuilder,
    private productService: ProductService,
    private ecryptService: EcryptServiceService,
    private companiesService: CompaniesService,
  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);

    this.url = this.router.url || '';

    this.data = data;

    console.log("data", this.data);


  }

  attendeeForm: any;

  // type: any;

  ngOnInit(): void {

    this.initGoogleCalendarform();

    try {
      const encryptedData = localStorage.getItem('crmSettingsData');
      if (encryptedData) {

        const decrypted = this.ecryptService.decryptionAES(encryptedData);

        this.crmSettingsData = JSON.parse(decrypted);

        if (this.crmSettingsData['editCalenderLink'] != undefined) {

          this.editMeeetingLink = this.crmSettingsData['editCalenderLink']
        }


      }

    } catch (err) {
      console.error("Error decrypting crmSettingsData", err);
    }


    this.firstFormGroup.patchValue({
      type: this.data.type
    });

    if (this.data.id > 0) {
      this.getGoogleCalendarById(this.data.id);
      this.title = 'Edit Meeting'
    }
    else {
      this.id = 0;
      this.title = 'Add Meeting'
    }

    // this.type = this.data.type;

    this.text = "Save";

    this.attendeeForm = this.fb.group({
      email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')]
      ]
    });

    if (this.data?.leadName && this.data?.type === 1) {
      this.prefillLeadByName(this.data.leadName);
    }

    if (this.data?.leadName && this.data?.type === 2) {
      this.prefillCompanyByName(this.data.leadName);
    }

  }


  prefillLeadByName(leadName: string): void {
    this.getLeadData(leadName);

    setTimeout(() => {
      const matchedLead = this.leadList.find(
        (lead) => lead.name?.toLowerCase() === leadName.toLowerCase()
      );


      if (matchedLead) {
        this.selectedLeads = [matchedLead];
        this.firstFormGroup.patchValue({
          entityId: matchedLead.entityId,
          name: matchedLead.name,
        });

        if (matchedLead.email) {
          this.selectedAttendees.push({ email: matchedLead.email });
          this.attendeeForm.patchValue({ email: matchedLead.email });
        }
      }


    }, 800);
  }



  prefillCompanyByName(name: string): void {
    this.getCompanyData(name);

    setTimeout(() => {
      const matchedCompany = this.companyList?.find(
        (c) => c.name?.toLowerCase() === name.toLowerCase()
      );

      if (matchedCompany) {
        this.selectedLeads = [matchedCompany];
        this.firstFormGroup.patchValue({
          entityId: matchedCompany.entityId,
          name: matchedCompany.name,
        });
      }
    }, 800);
  }



  initGoogleCalendarform() {
    this.firstFormGroup = this._formBuilder.group({
      googleCalenderId: [0],
      summary: ['', Validators.required],
      description: ['', Validators.required],
      location: [''],
      timeZone: ['Asia/Kolkata'],
      eventId: [0],
      startDateTime: ['', Validators.required],
      endDateTime: ['', Validators.required],
      attendees: [''],
      meetLink: [''],
      data: [],
      startTime: ['', Validators.required],
      endTime: ['', Validators.required],
      meetingSummary: [''],
      status: ['Pending'],
      ownerId: [''],
      updatedBy: [''],
      createdBy: [''],
      entityId: [''],
      name: [''],
      type: [''],
      meetingType: [1],
      meetingDriveLink: [''],

    }, { validators: dateTimeRangeValidator() });
  }


  meetingType = [
    { viewValue: 'Online Meeting', value: 1 },
    { viewValue: 'site Visit', value: 0 }
  ];
  audit(i) {

    if (window.innerWidth > 768) {
      let dialogRef = this.dialog.open(CalsoftAuditComponent, {
        width: '900px',
        disableClose: true,
        data: { page: i, }
      });
      dialogRef.disableClose = false;
      dialogRef.afterClosed().subscribe(result => {

      });
    }
    else {
      let dialogRef = this.dialog.open(CalsoftAuditComponent, {
        minWidth: '100vw', height: '100vh',
        data: { page: i, }
      });
      dialogRef.disableClose = false;
      dialogRef.afterClosed().subscribe(result => {



      });
    }
  }

  getGoogleCalendarById(pk: number) {
    this.googleCalendarServiceAccountService.getGoogleCalendarById(pk)
      .subscribe(
        (googleCalendar: any) =>
          this.editGoogleCalendarform(googleCalendar),
        (err: any) => { }
      );
  }

  today: Date = new Date();

  editGoogleCalendarform(calendar: any) {


    const originalStartDate = new Date(calendar.startDateTime);
    const today = new Date();
    today.setHours(0, 0, 0, 0);


    if (originalStartDate < today) {
      this.minDate = originalStartDate;
    } else {
      this.minDate = today;
    }

    this.selectedLeads = [];
    this.selectedAttendees = [];


    if (calendar.entityId && calendar.name) {
      const ids = calendar.entityId.split(',').map((id: string) => id.trim());
      const names = calendar.name.split(',').map((n: string) => n.trim());
      for (let i = 0; i < ids.length; i++) {
        this.selectedLeads.push({
          entityId: ids[i],
          name: names[i] || ''
        });
      }
    }

    if (calendar.attendees) {
      const emails = calendar.attendees.split(',').map((e: string) => e.trim());
      for (let i = 0; i < emails.length; i++) {
        this.selectedAttendees.push({
          email: emails[i],
          name: emails[i]
        });
      }
    }


    this.firstFormGroup = this._formBuilder.group({
      googleCalenderId: calendar.googleCalenderId,
      summary: calendar.summary,
      description: calendar.description,
      location: calendar.location,
      timeZone: calendar.timeZone,
      eventId: calendar.eventId,
      startDateTime: calendar.startDateTime,
      startTime: calendar.startTime,
      endDateTime: calendar.endDateTime,
      endTime: calendar.endTime,
      attendees: calendar.attendees,
      meetLink: calendar.meetLink,
      data: calendar.data,
      meetingSummary: calendar.meetingSummary,
      status: calendar.status,
      ownerId: calendar.ownerId,
      updatedBy: calendar.updatedBy,
      createdBy: calendar.createdBy,
      entityId: calendar.entityId,
      name: calendar.name,
      meetingDriveLink: calendar.meetingDriveLink,
      type: calendar.type,
      meetingType: calendar.meetingType,
    });

  }




  createCalenderEvent() {

    const status = this.firstFormGroup.get('status')?.value;
    const meetingSummary = this.firstFormGroup.get('meetingSummary');

    if (meetingSummary) {
      if (status === 'Completed') {
        meetingSummary.setValidators([Validators.required]);
      } else {
        meetingSummary.clearValidators();
      }
      meetingSummary.updateValueAndValidity();
    }


    // this.firstFormGroup.value.attendees = this.prepareAttendeesForSave();

    const attendeesEmails = this.prepareAttendeesForSave();
    const attendeesControl = this.firstFormGroup.get('attendees');

    if (attendeesEmails === null) {
      attendeesControl?.setValidators([Validators.required]);
      attendeesControl?.updateValueAndValidity();
    } else {
      attendeesControl?.clearValidators();
      attendeesControl?.setValue(attendeesEmails);
      attendeesControl?.updateValueAndValidity();
    }


    if (this.text == 'Save' && this.firstFormGroup.valid) {
      if (this.id != 0) {
        this.firstFormGroup.value.operationType = "Change"
      }
      else {
        this.firstFormGroup.value.operationType = "New"
      }



      this.firstFormGroup.value.name = this.prepareNameForSave();

      this.firstFormGroup.value.startDateTime = this.getCombinedDateTime(this.firstFormGroup.value.startDateTime,
        this.firstFormGroup.value.startTime)

      this.firstFormGroup.value.endDateTime = this.getCombinedDateTime(this.firstFormGroup.value.endDateTime,
        this.firstFormGroup.value.endTime)


      this.firstFormGroup.patchValue(this.firstFormGroup.value);

      this.text = "Processing";

      let i = 0;

      this.firstFormGroup.patchValue(this.firstFormGroup.value);

      if (this.firstFormGroup.value.entityId == null || this.firstFormGroup.value.entityId == '') {
        this.firstFormGroup.patchValue({
          entityId: this.data.leadId
        });
      }

      // this.firstFormGroup.patchValue({
      //   type: this.data.type
      // });

      this.googleCalendarServiceAccountService.addOrEditGoogleCalendar(this.firstFormGroup.value).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.text = "Save";
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });

            this.close();


          }
          else {
            this.text = "Save";
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }
        },
        (err) => { this.text = "Save" });
    }
    else {

      if (this.selectedAttendees.length == 0) {

        this.snackBar.open('Add one Attendee atleast', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
      }
      this.firstFormGroup.markAllAsTouched();

      console.log(this.firstFormGroup);

    }
  }

  close() {
    this.dialogRef.close({ event: 'add', })
  }


  cancel() {
    this.location.back()
  }

  scopes = [
    { "viewValue": "Yes", "value": 1 },
    { "viewValue": "No", "value": 0 }
  ]


  status = [
    { "viewValue": "Pending", "value": "Pending" },
    { "viewValue": "Cancel", "value": "Cancel" },
    { "viewValue": "Completed", "value": "Completed" },
    { "viewValue": "Reschedule", "value": "Reschedule" }
  ]


  attendeesList: any = [];


  removeLinkedCustomer(index) {


    this.attendeesList.splice(index, 1);

    (<UntypedFormArray>this.firstFormGroup.get('crmUserGroupEntity')).removeAt(index);
  }

  relatedCustomerList = [];
  customerSuperLinkList = [];

  statuss = [
    { viewValue: "Active", value: 1 },
    { viewValue: "Inactive", value: 0 }
  ]

  zone: TimezoneOption[] = TIMEZONE_ZONES;

  getCombinedDateTime(date, time): Date {
    const [hour, minute] = time.split(':').map(Number);
    date = new Date(date);

    date.setHours(hour);
    date.setMinutes(minute);
    date.setSeconds(0);
    date.setMilliseconds(0);

    return date;
  }


  email: string = '';
  emails: string[] = [];
  //dialogRef!: MatDialogRef<any>;

  openDialog(templateRef: TemplateRef<any>) {
    this.email = '';
    this.emails = [];

    this.dialogRef = this.dialog.open(templateRef, {
      disableClose: true,
      width: window.innerWidth > 768 ? '900px' : '100vw',
      height: window.innerWidth > 768 ? '' : '100vh',
      panelClass: window.innerWidth > 768 ? '' : 'full-screen-dialog'
    });

    this.dialogRef.afterClosed().subscribe(() => {
      // optional: clean up
    });
  }


  closeDialog() {
    this.dialogRef.close();
  }






  addAttendee() {
    const email = this.attendeeForm.get('email')?.value.trim();
    if (email) {
      this.attendeesList.push(email);
      this.attendeeForm.reset();
    }
  }

  removeEmail(index: number) {
    this.emails.splice(index, 1);
  }

  confirmAddAttendees() {
    if (this.emails.length > 0) {
      this.attendeesList.push(...this.emails);
      this.emails = []; // clear temp list after confirming
    }
    this.dialogRef.close();
  }


  separatorKeysCodes: number[] = [ENTER, COMMA];
  leadCtrl = new FormControl();
  leadList: any[] = [];
  selectedLeads: any[] = [];


  @ViewChild('leadInput') leadInput: ElementRef<HTMLInputElement>;

  onLeadSelected(option) {

    if (!this.selectedLeads.some(l => l.entityId === option.entityId)) {
      this.selectedLeads.push(option);
    }

    this.leadCtrl.setValue(null);
    if (this.leadInput) {
      this.leadInput.nativeElement.value = '';
    }

  }

  removeLead(item: any): void {
    const index = this.selectedLeads.indexOf(item);
    if (index >= 0) {
      this.selectedLeads.splice(index, 1);
    }
  }

  onInputPaitent(event: Event, dropdownType): void {
    let inputElement = event.target as HTMLInputElement;
    let inputValue = inputElement.value.trim();

    if (inputValue.length > 2) {

      if (dropdownType == 1) {
        this.getLeadData(inputValue);

        // Check if input looks like an email and show add new option for attendees
        if (this.isValidEmail(inputValue)) {
          const existingAttendee = this.leadList?.find(lead =>
            lead.email?.toLowerCase() === inputValue.toLowerCase()
          );

          if (!existingAttendee && !this.selectedAttendees.some(a => a.email === inputValue)) {
            this.showAddNewOption = true;
          } else {
            this.showAddNewOption = false;
          }
        } else {
          this.showAddNewOption = false;
        }
      } else {
        this.getCompanyData(inputValue);
      }
    } else {
      this.showAddNewOption = false;
    }
  }


  companyList: any;


  getCompanyData(value) {

    if (value != '') {

      let sortParam = 'updatedDate' + "," + Constant.Dsc;

      let search = "name:" + '*' + value.trim() + '*'
        + "' OR phoneNumber:" + '*' + value.trim() + '*'
        + "' OR ownerEmail:" + '*' + value.trim() + '*' + "' "

      this.companiesService.getCompanyBySearch(search, this.page, this.size, sortParam).subscribe(
        res => {

          this.companyList = res['content'];

        },
        error => {

        })


    }


  }

  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;
  getLeadData(value) {


    let sortParam = 'updatedDate' + "," + Constant.Dsc;

    const companyId = this.data.leadId;

    const trimmed = value.trim();

    let search = ""

    if (this.data.type = '1') {
      search = "name:" + '*' + value.trim() + '*'
        + "' OR phoneNumber:" + '*' + value.trim() + '*'
        + "' OR ownerEmail:" + '*' + value.trim() + '*' + "' "
    } else {

      search =
        `(name:*${trimmed}* OR phoneNumber:*${trimmed}* OR ownerEmail:*${trimmed}*)` +
        ` AND companyId:${companyId}`;
    }


    this.productService.getLeadBySearch(search, this.page, this.size, sortParam).subscribe(
      res => {

        this.leadList = res['content'];




      },
      error => {

      })

  }


  //attendess

  attendeeCtrl = new FormControl();
  attendeeList: any[] = [];
  selectedAttendees: any[] = [];
  showAddNewOption: boolean = false;
  newAttendeeOption: any = null;

  @ViewChild('attendeeInput') attendeeInput: ElementRef<HTMLInputElement>;

  onAttendeeSelected(option, value) {
    console.log(value);

    if (typeof option === 'string' || option == null) {
      option = { email: option || value }; // convert to object
    }
    if (option === 'ADD_NEW_ATTENDEE') {
      // Add new attendee from manual input
      this.addNewAttendeeFromInput();
    } else {
      // Add existing attendee from list
      if (!this.selectedAttendees.some(a => a.email === option.email)) {
        this.selectedAttendees.push(option);
      }
    }
    this.attendeeCtrl.setValue(null);
    if (this.attendeeInput) {
      this.attendeeInput.nativeElement.value = '';
    }
    this.showAddNewOption = false;
  }

  // Add new attendee by pressing Enter
  addNewAttendee(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.addNewAttendeeFromInput();
    }
  }

  // Helper method to add new attendee from input value
  addNewAttendeeFromInput(): void {
    const inputValue = this.attendeeCtrl.value?.trim();
    if (inputValue && this.isValidEmail(inputValue)) {
      const newAttendee = {
        email: inputValue,
        name: inputValue,
        entityId: null
      };

      if (!this.selectedAttendees.some(a => a.email === inputValue)) {
        this.selectedAttendees.push(newAttendee);
      }

      this.attendeeCtrl.setValue(null);
      if (this.attendeeInput) {
        this.attendeeInput.nativeElement.value = '';
      }
      this.showAddNewOption = false;
    }
  }

  // Email validation helper
  isValidEmail(email: string): boolean {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  }

  // remove chip
  removeAttendee(item: any): void {
    const index = this.selectedAttendees.indexOf(item);
    if (index >= 0) {
      this.selectedAttendees.splice(index, 1);
    }
  }

  prepareAttendeesForSave() {
    const emails = this.selectedAttendees
      .map(a => a.email?.trim())   // safely handle if a.email is undefined
      .filter(email => !!email);   // keep only truthy (non-empty) emails

    if (emails.length === 0) {
      this.snackBar.open("Email not found", '×', {
        panelClass: 'error',
        verticalPosition: 'bottom',
        duration: 500
      });
      return null; // or return '' if you prefer
    }

    return emails.join(',');
  }

  prepareEntityIdForSave() {
    return this.selectedLeads
      .map(a => a.entityId)
      .filter(id => !!id)
      .join(',');
  }

  prepareNameForSave() {
    return this.selectedLeads
      .map(a => a.name?.trim())
      .filter(name => !!name)
      .join(',');
  }

  generationLink() {
    this.googleCalendarServiceAccountService.generateMeetLink(this.data.id).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.text = "Save";
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.firstFormGroup.value.referralId = response['data'];
          this.firstFormGroup.patchValue(this.firstFormGroup.value);
        }
        else {
          this.text = "Save";
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
      },
      (err) => { this.text = "Save" });
  }


  copyToClipboard(text: string): void {
    const tempTextArea = document.createElement('textarea');
    tempTextArea.value = text;
    document.body.appendChild(tempTextArea);
    tempTextArea.select();
    document.execCommand('copy');
    document.body.removeChild(tempTextArea);
    this.snackBar.open('Copied to clipboard!', 'X', {
      duration: 3000,
      verticalPosition: 'bottom',
      panelClass: ['success'],
    });
  }

  navigationTo(value) {
    window.open(value, '_blank');
  }



  selectedFile: File | null = null;


  isFileUploaded = false;

  onFileChange(event: any): void {
    const file = event.target.files[0];

    if (!file) {
      console.error('No file selected');
      return;
    }

    this.selectedFile = file;
  }

  uploadedEmails: string[] = [];


  uploadFile(): void {
    if (!this.selectedFile) {
      console.error('No file to upload');
      return;
    }

    const reader: FileReader = new FileReader();

    reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
      const emails = data.slice(1).map((row: any[]) => row[0]).filter(email => !!email && typeof email === 'string');

      const uniqueUploadedEmails = Array.from(new Set(emails));

      const newEmails = uniqueUploadedEmails.filter(email => !this.attendeesList.includes(email));


      this.attendeesList.push(...newEmails);
      this.uploadedEmails = newEmails; // Track added emails
      this.selectedFile = null;
      this.isFileUploaded = true;
    };

    reader.readAsBinaryString(this.selectedFile);
  }



  cancelUpload(): void {
    this.attendeesList = this.attendeesList.filter(email => !this.uploadedEmails.includes(email));
    this.uploadedEmails = [];
    this.selectedFile = null;
    this.isFileUploaded = false;
  }

  sanitizeUrl(u: string): string {
    return (u || '').replace(/^\/+/, '').replace(/[?#&=]/g, '-').replace(/[^a-zA-Z0-9_-]+/g, '-').replace(/-+/g, '-').replace(/^[-]+|[-]+$/g, '').toLowerCase();
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}

function dateTimeRangeValidator(): ValidatorFn {
  return (group: AbstractControl): { [key: string]: any } | null => {
    const startDate = group.get('startDateTime')?.value;
    const startTime = group.get('startTime')?.value;
    const endDate = group.get('endDateTime')?.value;
    const endTime = group.get('endTime')?.value;

    if (startDate && startTime && endDate && endTime) {
      const start = new Date(startDate);
      const [startHours, startMinutes] = startTime.split(':').map(Number);
      start.setHours(startHours, startMinutes, 0, 0);

      const end = new Date(endDate);
      const [endHours, endMinutes] = endTime.split(':').map(Number);
      end.setHours(endHours, endMinutes, 0, 0);

      return end >= start ? null : { dateTimeInvalid: true };
    }
    return null;
  };
}
